import { render, staticRenderFns } from "./STableLaboratoriesComp.vue?vue&type=template&id=e077d0ae&"
import script from "./STableLaboratoriesComp.vue?vue&type=script&lang=js&"
export * from "./STableLaboratoriesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports